module.exports = __webpack_public_path__ + "media/images/lb/698-35ec630b30ee903e32a8b8ec732c63f5.svg";